export class BaseRequestFormatter {
    constructor(options) {
        this.format = (request, baseUrl, signal) => {
            const url = this.urlFormatter.format(request, baseUrl);
            const options = this.optionsFormatter.format(request, signal);
            return new Request(url, options);
        };
        this.urlFormatter = options.urlFormatter;
        this.optionsFormatter = options.optionsFormatter;
    }
}
//# sourceMappingURL=BaseRequestFormatter.js.map